import { type FC, type ReactNode, useRef } from "react";

import { AssistantScope } from "@app_schema";

import { useFillHeight } from "@application/hooks/use_fill_height";

import { AssistantSplit, AssistantSplitSide } from "@styled/assistant_split";
import { SplitToolbar } from "@styled/split_toolbar";

import { AssistantPane } from "./assistant_pane";
import { AssistantToolbar } from "./assistant_toolbar";
import { useAssistantChats } from "./use_assistant_chats";

const noPage = () => undefined;

// The Records assistant before the records are processed: it says so, beside
// the card that processes them.
export const LockedRecordsSplit: FC<{
  projectId: string;
  children: ReactNode;
}> = ({ projectId, children }) => {
  const chats = useAssistantChats({
    projectId,
    scope: AssistantScope.Records,
    open: true,
  });
  const fillRef = useRef<HTMLDivElement>(null);
  const height = useFillHeight(fillRef, true);

  return (
    <AssistantSplit
      fillRef={fillRef}
      height={height}
      toolbar={
        <SplitToolbar
          left={<AssistantToolbar chats={chats} available={false} />}
          right={null}
        />
      }
    >
      <AssistantPane
        chats={chats}
        scope={AssistantScope.Records}
        available={false}
        agentReady={false}
        activePage={null}
        onOpenPage={noPage}
      />
      <AssistantSplitSide>{children}</AssistantSplitSide>
    </AssistantSplit>
  );
};
